<div class="d-flex align-items-center">
  <button type="button" class="btn-primary" (click)="claveunica()">
    <span
      class="btn__icon"
      style="--icon: url('assets/icon/cu-blanco.svg')"
      aria-hidden="true"
    ></span>
    <span class="btn__label">ClaveÚnica</span>
  </button>
</div>
